import { render } from "./ExportButton.vue?vue&type=template&id=9156b852"
import script from "./ExportButton.vue?vue&type=script&lang=js"
export * from "./ExportButton.vue?vue&type=script&lang=js"
script.render = render

export default script